import React from 'react';
import './Shows.css';

function Shows() {
  return (
    <div className='shows-container'>
      <h1 className='section-header'>Upcoming Shows</h1>
        <a className='show-link' href='https://www.instagram.com/joonipea/'>Pisces Venus Release Party</a>
      <h1 className='section-header'>Past Shows</h1>
    </div>
  );
}

export default Shows;
